<div class="dealer">
    <!-- Profile Image Section -->
    <app-avatar-uploader
        [imageUrl]="
            profilePicturePreview() || $any(draftData())?.profilePicture || '/default_profile.png'
        "
        (invalidFileSelected)="onInvalidFileSelected()"
        (imageChange)="onImageChange($event)" />

    <p class="dealer__form-instruction">
        Fill the form below to create a new {{ selectedUserType()?.label }}.
    </p>

    <!-- Form Section -->
    <form class="dealer__form" [formGroup]="form()">
        <div class="dealer__grid">
            @for (field of formFields(); track field.fieldName) {
                <div
                    class="dealer__field"
                    [class]="'dealer__field--' + field.gridSpan"
                    [class.dealer__field--read-only-display]="
                        isReadOnlyProfileLocationField(field.fieldName)
                    ">
                    @if (field.type === 'autocomplete') {
                        <app-autocomplete
                            [options]="cityList()"
                            [loading]="isLoadingCities()"
                            [minCharsForSearch]="3"
                            [selectionIdentityProp]="'selectionKey'"
                            [config]="{
                                placeholder: 'Type a city or state (min: 3 characters)',
                                label: 'City',
                            }"
                            [formControlName]="field.fieldName"
                            [error]="getFieldErrorMessage(field.fieldName)[0]"
                            (onSelect)="onSelect($event)"
                            (onSearch)="onSearch($event)" />
                    } @else {
                        <ntv-input
                            [label]="field.label"
                            [formControlName]="field.fieldName"
                            [placeholder]="field.placeholder"
                            [type]="$any(field.type)"
                            [maxLength]="
                                isContactNumberField(field.fieldName)
                                    ? 10
                                    : isPasswordField(field.fieldName)
                                      ? 72
                                      : null
                            "
                            (keydown)="onNumericKeydown($event, field.fieldName)"
                            (keydown)="onPasswordKeydown($event, field.fieldName)"
                            (focus)="onFocus(field.fieldName)"
                            [error]="getFieldErrorMessage(field.fieldName)[0]"></ntv-input>
                    }
                </div>
            }
        </div>
    </form>

    <!-- Password Requirements -->
    <div class="dealer__password-requirements">
        <div class="dealer__requirements-header">
            <svg class="dealer__requirements-icon" width="24" height="24" style="fill: none">
                <use href="assets/icons/icons-sprite.svg#shield"></use>
            </svg>
            <span class="dealer__requirements-title">Password Requirements:</span>
        </div>
        <ul class="dealer__requirements-list">
            <li>At least 8 characters long</li>
            <li>Contains uppercase and lowercase letters</li>
            <li>Contains at least one number</li>
            <li>Contains at least one special character</li>
        </ul>
    </div>
</div>

@if (showInvalidFileModal()) {
    <div class="dealer__invalid-file-backdrop" (click)="closeInvalidFileModal()">
        <div class="dealer__invalid-file-modal" (click)="$event.stopPropagation()">
            <h3>Invalid File Selected</h3>
            <p>Please select an image file in JPG, JPEG, or PNG format only.</p>
            <button
                type="button"
                class="dealer__invalid-file-button"
                (click)="closeInvalidFileModal()">
                OK
            </button>
        </div>
    </div>
}
